export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5373.d3d0973c.jpg";